/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2017, 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'dashboard-analytics/dialogs/CommonViewWrapper',
	'./NonNumericHighlightFilterController'
], function(View, FilterController) {
	var Wrapper = View.extend({

		className: 'timelineHighlightViewWrapper',

		init: function() {
			Wrapper.inherited('init', this, arguments);
		},

		// @override: Need to preload to have the Flyout sized properly.
		preload: function() {
			this.options.commonView = this;
			this.filterController = new FilterController(this.options);
			return this.filterController.initialize();
		}
	});

	return Wrapper;
});
